/**
 * Generates the Google Analytics meta object.
 *
 * @param category
 * @param action
 * @param label
 * @param value
 * @returns {{analytics: *[]}}
 */
export const eventTracker = (category, action, label, value) => {
    return {
        analytics: [
            ['event', {
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
                eventValue: value
            }]
        ]
    }
}


// WEBPACK FOOTER //
// ./src/services/GoogleAnalyticsService.js